import { createStateSelectorHook } from 'src/lib/sweetState';

import { DocumentViewStore } from '../store';

const useDocumentViewState = createStateSelectorHook(DocumentViewStore, [
  'editorSelectedVariationInstanceId',
  'editorHoveredVariationInstanceId',
  'detailsPanelVisibleForVariationInstanceId',
]);

/**
 * We should have only one highlighted variation in the document editor view.
 * When deciding which variation should be highlighted, we use this priority:
 *   1) variation for which "details panel" is opened - top priority
 *   2) variation which is hovered by mouse cursor
 *   3) variation in which text cursor is placed
 */
export const useDocumentActiveVariationInstanceId = () => {
  const {
    editorSelectedVariationInstanceId,
    editorHoveredVariationInstanceId,
    detailsPanelVisibleForVariationInstanceId,
  } = useDocumentViewState();

  if (detailsPanelVisibleForVariationInstanceId) {
    return detailsPanelVisibleForVariationInstanceId;
  }
  if (editorHoveredVariationInstanceId) {
    return editorHoveredVariationInstanceId;
  }
  return editorSelectedVariationInstanceId;
};
